import autoTable from "jspdf-autotable";

import {
  PDF_TABLE_STYLE,
  PDFCOLORSHEME,
} from "../../../../../../component/constent";

export function drawShopTable(doc, totals = {}, month, year) {
  /*
   * ==========================================
   * FORMAT NUMBER
   * ==========================================
   */
  const format = (value) => {
    return Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };



const pageWidth = doc.internal.pageSize.getWidth();

const margin = 8;

const tableWidth = pageWidth - margin * 2;


const columnRatios = [
  39, 25,
  42, 25,
  48, 25,
];

const ratioTotal = columnRatios.reduce((a, b) => a + b, 0);

const columnWidths = columnRatios.map(
  (ratio) => (tableWidth * ratio) / ratioTotal
);








  /*
   * ==========================================
   * DATA
   * ==========================================
   */

  // ---------------- DEBIT ----------------
  const ob = Number(totals.OB) || 0;

  const labour = Number(totals.labour) || 0;
  const store = Number(totals.store) || 0;
  const freight = Number(totals.freight) || 0;
  const proforma = Number(totals.proforma) || 0;

  const totalDebit =
    labour +
    store +
    freight +
    proforma;

  const grandTotalDebit =
    ob +
    totalDebit;

  // ---------------- DETAILS OF REVENUE ----------------
  const jv5 = Number(totals.jv5) || 0;
  const jv6 = Number(totals.jv6) || 0;
  const jv7 = Number(totals.jv7) || 0;
  const jv12 = Number(totals.jv12) || 0;

  const part1 = Number(totals.part1) || 0;
  const bulkOrder = Number(totals.bulkorder) || 0;

  const totalRevenue =
    jv5 +
    jv6 +
    jv7 +
    jv12 +
    part1 +
    bulkOrder;

  // ---------------- CREDIT ----------------
  const poh = Number(totals.POH) || 0;
  const drr = Number(totals.DRR) || 0;
  const returnStore = Number(totals.ReturnStore) || 0;
  const electrical = Number(totals.Electrical) || 0;

  /*
   * Revenue Total appears in CREDIT section
   */
  const revenueTotal = totalRevenue;

  const totalCredit =
    poh +
    drr +
    returnStore +
    electrical +
    revenueTotal;

  /*
   * Closing Balance
   */
  const closingBalance =
    grandTotalDebit -
    totalCredit;

  /*
   * Grand Total Credit
   */
  const grandTotalCredit =
    totalCredit +
    closingBalance;

  /*
   * ==========================================
   * START POSITION
   * ==========================================
   */

  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 15
    : 30;

  const pageHeight =
    doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 70) {
    doc.addPage();
    startY = 30;
  }

  /*
   * ==========================================
   * TITLE
   * ==========================================
   */

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);

  doc.text(
    `WORKSHOP ACCOUNT FOR Month of ${String(
      month
    ).toUpperCase()}-${year} FOR MACHENICAL WORKSHOP, NER, GORAKHPUR`,
    148.5,
    startY - 8,
    {
      align: "center",
    }
  );

  /*
   * ==========================================
   * TABLE
   * ==========================================
   */

  autoTable(doc, {
    startY,

    ...PDF_TABLE_STYLE,

    margin: {
    left: margin,
    right: margin,
  },

  tableWidth: tableWidth,

    head: [
      [
        {
          content: "DEBIT",
          colSpan: 2,
          styles: {
            fillColor: [190, 245, 190],
            textColor: [0, 0, 0],
            halign: "center",
            fontStyle: "bold",
            fontSize: 11,
          },
        },

        {
          content: "DETAILS OF REVENUE",
          colSpan: 2,
          styles: {
            fillColor: [255, 250, 170],
            textColor: [0, 0, 0],
            halign: "center",
            fontStyle: "bold",
            fontSize: 11,
          },
        },

        {
          content: "CREDIT",
          colSpan: 2,
          styles: {
            fillColor: [245, 185, 185],
            textColor: [0, 0, 0],
            halign: "center",
            fontStyle: "bold",
            fontSize: 11,
          },
        },
      ],

      [
        "PARTICULARS",
        "AMOUNT",
        "PARTICULARS",
        "AMOUNT",
        "PARTICULARS",
        "AMOUNT",
      ],
    ],

    body: [
      /*
       * ==========================
       * OPENING BALANCE
       * ==========================
       */
      [
        {
          content: "OPENING BALANCE",
          styles: {
            fillColor: [198, 245, 198],
            fontStyle: "bold",
          },
        },

        {
          content: format(ob),
          styles: {
            fillColor: [198, 245, 198],
            fontStyle: "bold",
            halign: "right",
          },
        },

        "",
        "",
        "",
        "",
      ],

      /*
       * ==========================
       * LABOUR
       * ==========================
       */
      [
        "LABOUR",
        format(labour),

        "DEMAND NO. 5",
        format(jv5),

        "Cost of POH/IOH Foreign Railway",
        format(poh),
      ],

      /*
       * ==========================
       * STORE
       * ==========================
       */
      [
        "STORE",
        format(store),

        "DEMAND NO. 6",
        format(jv6),

        "DRR",
        format(drr),
      ],

      /*
       * ==========================
       * FREIGHT
       * ==========================
       */
      [
        "FRIEGHT",
        format(freight),

        "DEMAND NO. 7",
        format(jv7),

        "Return Store",
        format(returnStore),
      ],

      /*
       * ==========================
       * PROFORMA
       * ==========================
       */
      [
        "PROFORMA ON COST",
        format(proforma),

        "DEMAND NO. 12",
        format(jv12),

        "Elect. Manufacturing",
        format(electrical),
      ],

      /*
       * ==========================
       * PART 1
       * ==========================
       */
      [
        "",
        "",

        "TD/XP/Part I (00-0882-22)",
        format(part1),

        "Revenue Total",
        format(revenueTotal),
      ],

      /*
       * ==========================
       * BULK ORDER
       * ==========================
       */
      [
        "",
        "",

        "Bulk Order (21-2130-08)",
        format(bulkOrder),

        "",
        "",
      ],

      /*
       * ==========================
       * TOTALS
       * ==========================
       */
      [
        {
          content: `Total Debit (${String(
            month
          ).toUpperCase()}-${year})`,
          styles: {
            fontStyle: "bold",
          },
        },

        {
          content: format(totalDebit),
          styles: {
            fontStyle: "bold",
            halign: "right",
          },
        },

        {
          content: "Total of Revenue",
          styles: {
            fillColor: [255, 250, 170],
            fontStyle: "bold",
          },
        },

        {
          content: format(totalRevenue),
          styles: {
            fillColor: [255, 250, 170],
            fontStyle: "bold",
            halign: "right",
          },
        },

        {
          content: `Total Credit (${String(
            month
          ).toUpperCase()}-${year})`,
          styles: {
            fontStyle: "bold",
          },
        },

        {
          content: format(totalCredit),
          styles: {
            fontStyle: "bold",
            halign: "right",
          },
        },
      ],

      /*
       * ==========================
       * CLOSING BALANCE
       * ==========================
       */
      [
        "",
        "",
        "",
        "",

        {
          content: "CLOSING BALANCE",
          styles: {
            fillColor: [245, 185, 185],
            fontStyle: "bold",
          },
        },

        {
          content: format(closingBalance),
          styles: {
            fillColor: [245, 185, 185],
            fontStyle: "bold",
            halign: "right",
          },
        },
      ],

      /*
       * ==========================
       * GRAND TOTAL
       * ==========================
       */
      [
        {
          content: "GRAND TOTAL DEBIT",
          styles: {
            fontStyle: "bold",
          },
        },

        {
          content: format(grandTotalDebit),
          styles: {
            fontStyle: "bold",
            halign: "right",
          },
        },

        "",
        "",

        {
          content: "GRAND TOTAL CREDIT",
          styles: {
            fontStyle: "bold",
          },
        },

        {
          content: format(grandTotalCredit),
          styles: {
            fontStyle: "bold",
            halign: "right",
          },
        },
      ],
    ],


columnStyles: {
    0: {
      cellWidth: columnWidths[0],
      halign: "left",
    },
    1: {
      cellWidth: columnWidths[1],
      halign: "right",
    },
    2: {
      cellWidth: columnWidths[2],
      halign: "left",
    },
    3: {
      cellWidth: columnWidths[3],
      halign: "right",
    },
    4: {
      cellWidth: columnWidths[4],
      halign: "left",
    },
    5: {
      cellWidth: columnWidths[5],
      halign: "right",
    },
  },




    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY || 8,
      cellPadding: 2.5,
      lineWidth: 0.25,
      lineColor: [70, 70, 70],
      textColor: [0, 0, 0],
      valign: "middle",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      halign: "center",
      fontStyle: "bold",
    },

   
    

    didParseCell(data) {
      /*
       * Make amount columns right aligned
       */
      if (
        data.column.index === 1 ||
        data.column.index === 3 ||
        data.column.index === 5
      ) {
        data.cell.styles.halign = "right";
      }
    },
  });

  /*
   * ==========================================
   * SIGNATURES
   * ==========================================
   */

  const finalY =
    doc.lastAutoTable.finalY;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);

  doc.text(
    "Dy CME/Repair",
    35,
    finalY + 22,
    {
      align: "center",
    }
  );

  doc.text(
    "Sr AFA/MWS",
    245,
    finalY + 22,
    {
      align: "center",
    }
  );

  /*
   * Keep finalY available for footer
   */
  doc.lastAutoTable.finalY =
    finalY + 25;
}